import React from "react";
import { Modal } from "rsuite";

const SuccessApproveAccount = ({
  successApproveAccountOpen,
  handleCloseSuccessApproveAccount,
}) => {
  return (
    <Modal
      size="sm"
      open={successApproveAccountOpen}
      onClose={handleCloseSuccessApproveAccount}
    >
      <div className="h-[250px] w-full flex flex-col gap-[40px] items-center justify-center">
        <p className="text-center text-[16px] font-[600]">SUCCESS!</p>
        <svg
          width="84"
          height="84"
          viewBox="0 0 84 84"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.0001 83.3333C64.8279 83.3333 83.3334 64.8278 83.3334 42C83.3334 19.1722 64.8279 0.666656 42.0001 0.666656C19.1723 0.666656 0.666748 19.1722 0.666748 42C0.666748 64.8278 19.1723 83.3333 42.0001 83.3333Z"
            fill="#F0FFFE"
          />
          <path
            d="M23.9167 36.8333L38.8691 51.7857C39.0144 51.9308 39.2114 52.0123 39.4167 52.0123C39.6221 52.0123 39.8191 51.9308 39.9644 51.7857L80.7501 11"
            stroke="black"
            stroke-width="1.2"
          />
        </svg>

        <p className="items-center text-center">
          National ID verified! <br />
          KRA PIN details match that of the member
        </p>
      </div>
    </Modal>
  );
};

export default SuccessApproveAccount;
